// Image path constants for AP Pacific
// All images should be placed in /frontend/public/images/

const IMAGES = {
  // Logos & Branding
  logos: {
    main: '/images/logos/aplogoproposal.png',
    badge24_7: '/images/logos/24-7.png',
  },

  // Industry Icons
  industries: {
    airline: '/images/industries/airline.png',
    autoMobile: '/images/industries/auto-mobile.png',
    entertainment: '/images/industries/entertainment.png',
    fitness: '/images/industries/fitness.png',
    medical: '/images/industries/medical.png',
    school: '/images/industries/school.png',
  },

  // Service Photos
  services: {
    carpetCleaning: '/images/services/306478-carpet-cleaning-services-1.jpg',
    carpetGeneral: '/images/services/carpet.jpg',
    commercialCarpet: '/images/services/commercial-office-carpet-cleaning-1600.jpg',
    petOdor: '/images/services/get-pet-odor-out-of-carpet.jpg',
    petStain: '/images/services/pet-dog-cat-urine-on-carpet.jpg',
    waterDamage1: '/images/services/water-damage-repair.jpg',
    waterDamage2: '/images/services/water-damage-repair2.jpg',
    waterDamageFr: '/images/services/water-damage-repair-u6109-fr.jpg',
  },

  // Equipment
  equipment: {
    prochemEverest: '/images/equipment/prochem-everest-605.gif',
    cleanWater: '/images/equipment/bigstock-clean-water-and-water-bubbles-261313161-u5760-fr.jpg',
  },

  // UI Elements
  ui: {
    arrows: {
      icon: '/images/ui/arrow-ico.png',
      left: '/images/ui/arrowleft.png',
      left2: '/images/ui/arrowleft2.png',
      leftH: '/images/ui/arrowlefth.png',
      right: '/images/ui/arrowright.png',
      right2: '/images/ui/arrowright2.png',
      rightH: '/images/ui/arrowrighth.png',
      sliderRight: '/images/ui/sliderightarrow.png',
      sliderLeft: '/images/ui/sliderleftarrow.png',
    },
    icons: {
      area: '/images/ui/area-icon.png',
      clock: '/images/ui/clock-icon.png',
      comment: '/images/ui/comment.png',
      customerService: '/images/ui/customer-service-icon.png',
      mobile: '/images/ui/mobile-icon.png',
      thumbs: '/images/ui/thumbs-icon.png',
    },
    backgrounds: {
      callOut: '/images/ui/call-out.jpg',
      callOut2: '/images/ui/call-out2.jpg',
      statistics: '/images/ui/statistics-bg.jpg',
      statistics2: '/images/ui/statistics-bg2.jpg',
      sidebar: '/images/ui/sidebar.jpg',
      capture: '/images/ui/capture.jpg',
    },
    features: {
      areWeServices: '/images/ui/are-we-services.png',
      fastService: '/images/ui/fast-service copy.png',
      highTrainedStaff: '/images/ui/high-trained-staff copy.png',
      qualityCleaningStaff: '/images/ui/quality-cleaning-staff copy.png',
    },
  },

  // Gallery/Portfolio Images
  gallery: {
    images4: '/images/gallery/images-4-u6106-fr.jpg',
    images6: '/images/gallery/images-6.jpg',
    images7: '/images/gallery/images-7-u6105-fr.jpg',
    images8: '/images/gallery/images-8-u6108-fr.jpg',
    images8Alt: '/images/gallery/images-8.jpg',
    images82: '/images/gallery/images-82.jpg',
    images9: '/images/gallery/images-9-u6107-fr.jpg',
    images9Alt: '/images/gallery/images-9.jpg',
    // Project photos
    img5844: '/images/gallery/img_5844-buttonu7355-fr.jpg',
    img5845: '/images/gallery/img_5845-buttonu7331-fr.jpg',
    img5846: '/images/gallery/img_5846-buttonu7343-fr.jpg',
    img5847: '/images/gallery/img_5847-buttonu7361-fr.jpg',
    img5848: '/images/gallery/img_5848-buttonu6441-fr.jpg',
    img5849: '/images/gallery/img_5849-buttonu6417-fr.jpg',
    img5850: '/images/gallery/img_5850-buttonu6423-fr.jpg',
    img5852: '/images/gallery/img_5852-buttonu6447-fr.jpg',
    img5854: '/images/gallery/img_5854-buttonu6435-fr.jpg',
    img5855: '/images/gallery/img_5855-buttonu6429-fr.jpg',
    img5856: '/images/gallery/img_5856-buttonu7337-fr.jpg',
    img5857: '/images/gallery/img_5857-buttonu7349-fr.jpg',
    // Stock photos
    atelier: '/images/gallery/atelierpictures-20131002-005.jpg',
    istockFr: '/images/gallery/istock_000013101710large-u5259-fr.jpg',
    istock: '/images/gallery/istock_000013101710large.jpg',
    reviews: '/images/gallery/reviews-e1429764864523.jpg',
  },
};

export default IMAGES;
